// @mui
import useMediaQuery from '@mui/material/useMediaQuery';
import {useTheme} from '@mui/material/styles';
// types
import type {Breakpoint} from '@mui/material';

// ----------------------------------------------------------------------

type TQueryParam = 'up' | 'down' | 'between' | 'only';
type TQueryKeyParam = Breakpoint;

function useResponsive(
  query: TQueryParam,
  key?: TQueryKeyParam,
  start?: TQueryKeyParam,
  end?: TQueryKeyParam
) {
  const theme = useTheme();

  const mediaUp = useMediaQuery(theme.breakpoints.up(key as TQueryKeyParam));

  const mediaDown = useMediaQuery(
    theme.breakpoints.down(key as TQueryKeyParam)
  );

  const mediaBetween = useMediaQuery(
    theme.breakpoints.between(start as TQueryKeyParam, end as TQueryKeyParam)
  );

  const mediaOnly = useMediaQuery(
    theme.breakpoints.only(key as TQueryKeyParam)
  );

  if (query === 'up') {
    return mediaUp;
  }

  if (query === 'down') {
    return mediaDown;
  }

  if (query === 'between') {
    return mediaBetween;
  }

  if (query === 'only') {
    return mediaOnly;
  }
  return null;
}

export { useResponsive };
